const freeShippingDefaultState = {
  freeShippingBar: null,
};

module.exports = freeShippingDefaultState;
